import ServiceRequestPage from '@/pages/services/service-request-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/service_request/$id')({
  component: ServiceRequestPage,
});
